import { render } from "./ProgressBar.vue?vue&type=template&id=66158b02"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"
script.render = render

export default script